// Contracts — javelin moderator cabinet stats (2026-06-11 QA3 №4).
// Worker side: apps/api/src/javelin/economics.ts cabinetStats(). Client
// side: apps/internal javelin island CabinetScreen. Mods-page semantics
// (managerOverview tab=mods) over the CURRENT iteration; scope=my
// (default) filters to the calling moderator, scope=all spans all
// moderators. earned_pre_kpi_usd is always the caller's own figure —
// the manager's earned_calc formula before any KPI bonus.
import { z } from 'zod';

export const JavCabinetStatsQuerySchema = z.object({
  scope: z.enum(['my', 'all']).optional(),
});

export const JavCabinetSkinCellSchema = z.looseObject({
  code: z.string(),
  count: z.number(),
  target: z.number(),
});

export const JavCabinetStatsResSchema = z.looseObject({
  scope: z.enum(['my', 'all']),
  iteration: z.string(),
  total: z.number(),
  accepted: z.number(),
  pending: z.number(),
  rejected: z.number(),
  cancelled: z.number(),
  kpi_percent: z.number(),
  today: z.number(),
  week: z.number(),
  earned_pre_kpi_usd: z.number(),
  skin_tone_distribution: z.array(JavCabinetSkinCellSchema),
  gender_distribution: z.looseObject({
    male: z.number(), female: z.number(), other: z.number(),
    pct_male: z.number(), pct_female: z.number(), pct_other: z.number(),
  }),
  age_distribution: z.looseObject({
    a18_35: z.number(), a36_54: z.number(), a55_70: z.number(),
    pct_18_35: z.number(), pct_36_54: z.number(), pct_55_70: z.number(),
  }),
});

export type JavCabinetStatsRes = z.infer<typeof JavCabinetStatsResSchema>;
